<template>
  <el-menu class="navbar px-5" mode="horizontal">
    <el-row type="flex" justify="space-between" class="fill-height">
      <el-col :span="14" class="left-menu">
        <hamburger class="hamburger-container mr-3" @toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
        <breadcrumb></breadcrumb>
      </el-col>
      <el-col class="fill-height">
        <div class="right-menu">
          <div class="walletImage" v-if="name != 'admin'">
            <el-image :src="require('@/assets/wallet.png')"></el-image>
          </div>
          <div class="avatar-name mr-3" v-if="name != 'admin'">
            <p class="name">Certificates credit</p>
            <p class="status" :style="{
              'font-weight': (role === 'Authenticated') ? 'bold' : 'bold'
            }">{{ this.balance ? this.balance : 0 }}</p>
          </div>
          <el-dropdown class="avatar-container right-menu-item" trigger="click">
            <div class="avatar-wrapper">
              <el-image class="user-avatar" :src="uniLogo" fit="scale-down"></el-image>
            </div>
            <el-dropdown-menu class="user-dropdown" slot="dropdown">
              <div>
                <el-dropdown-item class="inlineBlock">
                  {{ this.email }}
                </el-dropdown-item>
              </div>
              <div>
                <el-dropdown-item v-if="this.$route.name === 'Home'"
                  @click.native="$router.push({ name: 'Change Password' })">
                  <div>Change Password</div>
                </el-dropdown-item>
                <el-dropdown-item v-if="this.$route.name === 'Change Password'"
                  @click.native="$router.push({ name: 'Home' })">
                  <div>Home</div>
                </el-dropdown-item>
              </div>
              <!-- <el-dropdown-item divided>
                <span @click="logout" style="display:block;">Log Out</span>
              </el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import EventBus from '@/event/event-bus'
import uniLogos from '@/assets/js/logoMapping.js'
import isMobileMixin from '@/mixins/isMobileMixin.js'
export default {
  mixins: [isMobileMixin],
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      hardcodeUniLogo: uniLogos
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'balance',
      'role',
      'email',
      'name'
    ]),
    uniLogo() {
      if (this.role === 'Authenticated') {
        return `https://ui-avatars.com/api/?name=${this.email}`
      }
      return this.hardcodeUniLogo[this.name] ? this.hardcodeUniLogo[this.name] : `https://ui-avatars.com/api/?name=${this.name}`
    },
    theName() {
      if (this.role === 'Authenticated') {
        return this.email
      } else {
        return this.name
      }
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        EventBus.$emit('closeSocket')
        location.reload()
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../styles/variables.scss';
$mobile: 425px;
$tablet: 768px;

.navbar {
  height: 74px;
  // line-height: 50px;
  border-radius: 0px !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

  .left-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .hamburger-container {
    height: 20px;
    width: 20px;
    float: left;
    display: flex;
    align-items: center;
  }

  .walletImage {
    display: inline-flex;
    padding-right: 0.24em;
    min-width: 15%;
    max-height: 50%;
    margin-top: 16px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .right-menu {
    float: right;
    height: 100%;
    display: flex;

    justify-content: flex-end &:focus {
      outline: none;
    }

    .avatar-name {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      flex-direction: column;
      color: $navbarAvatarNameColor;

      @media screen and (max-width: $mobile) {
        display: none;
      }

      .name {
        font-size: 12px;
        text-align: left;
        color: inherit;
        font-weight: normal;
      }

      .status {
        font-size: 16px;
        text-align: left;
        color: inherit;
        font-weight: normal;
        color: black;
        width: 100%;
      }
    }

    .balance {
      display: inline-block;
      position: relative;
      top: -14px;

      .label {
        font-weight: 400;
        color: #606266;
        font-size: 13px;
      }
    }

    .right-menu-item {
      display: inline-block;
    }

    .avatar-container {
      height: 100%;
      display: flex;
      align-items: center;

      .avatar-wrapper {
        cursor: pointer;
        position: relative;

        .user-avatar {
          width: 47px;
          height: 47px;
          // border-radius: 10px;
        }

        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

.inlineBlock:hover {
  cursor: default;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue